module.exports = __webpack_public_path__ + "Roboto-Condensed-Bold.fd2a9a672da0c95d1ebe.woff";


//////////////////
// WEBPACK FOOTER
// /Users/vladislavlazurenko/IdeaProjects/luiziana/frontend/src/roboto-fontface/fonts/roboto/Roboto-Condensed-Bold.woff
// module id = ../../../../../src/roboto-fontface/fonts/roboto/Roboto-Condensed-Bold.woff
// module chunks = styles